import { CompanyResponseType } from '../../../../pages/admin-dashboard/admin-companies/admin-companies.model';
import { CompanyModel } from './view-all-companies-component.model';

function companyMapper(item: CompanyResponseType, isArabic: boolean, index: number): CompanyModel {
  return {
    companyName: isArabic ? item.titleAr : item.titleEn,
    createdBy: item.createdBy.fullName,
    createdOn: item.createdOn,
    id: (index + 1).toString(),
  };
}

export function companiesMapper(companiesData: CompanyResponseType[], isArabic: boolean) {
  const companies = companiesData.map((item, index: number) => companyMapper(item, isArabic, index));
  return companies;
}
